module.exports = __webpack_public_path__ + "static/img/fur.4e14bd2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cover/20210918/fur.jpg
// module id = em5F
// module chunks = 1